import { render, staticRenderFns } from "./buildList.vue?vue&type=template&id=2d96f0f4&scoped=true"
import script from "./buildList.vue?vue&type=script&lang=js"
export * from "./buildList.vue?vue&type=script&lang=js"
import style0 from "./buildList.vue?vue&type=style&index=0&id=2d96f0f4&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d96f0f4",
  null
  
)

export default component.exports